// extracted by mini-css-extract-plugin
export default {"box":"UnblockUser_box__x3Cdg","selectTitle":"UnblockUser_selectTitle__Biqg2","title":"UnblockUser_title__g32dF","inputTitle":"UnblockUser_inputTitle__dC676"};